import initSupervisorSearch from "./supervisorSearch";
import initFellowSearch from "./fellowSearch";

window.addEventListener("load", function () {

	document.querySelectorAll('.confirm-btn').forEach(btn => {
		btn.addEventListener('click', e => {
			if (!confirm(btn.title)) {
				e.preventDefault();
			}
		});
	});

	initSupervisorSearch();
	initFellowSearch();
});
